import { Controller } from '@hotwired/stimulus'
import { ImageViewer } from '../modules/viewer'

// Generic gallery controller. Mount on any container that holds img elements
// with data-full / data-type / data-download attributes. Trigger opening via:
//   data-action="click->gallery#open"
// Optionally specify which image to open with a Stimulus param:
//   data-gallery-index-param="2"
export default class extends Controller {
  connect() {
    this._viewer = new ImageViewer(this.element)
  }

  disconnect() {
    this._viewer?.viewer?.destroy()
    this._viewer = null
  }

  open(event) {
    event.preventDefault()
    const index = event.params?.index ?? 0
    this._viewer?.view(index)
  }
}
